module.exports = __webpack_public_path__ + "static/media/IMG.success.409a92ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/node_modules/kts-scaffold-framework/component/Message/IMG.success.svg
// module id = 2440
// module chunks = 0